module.exports = __webpack_public_path__ + "img/Categoria_05_Estrangeria_60_x_60_pixels_v3.9841b272.png";